import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { isPackagesPageEligible } from '../../core/utils/packages-region.util';

@Injectable()
export class PackagesRegionGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    if (isPackagesPageEligible()) {
      return true;
    }

    this.router.navigate(['dashboard/supplier/ecommerce']);
    return false;
  }
}
